// extracted by mini-css-extract-plugin
module.exports = {"form":"Settings_form__4XdQ6","userActions":"Settings_userActions__1bwY3"};